import { render, staticRenderFns } from "./MrItemProduct.vue?vue&type=template&id=8eff1164&"
import script from "./MrItemProduct.vue?vue&type=script&lang=js&"
export * from "./MrItemProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports